import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { t } from '../../translations/translations';
import { HOW_IT_WORKS_STEPS } from '../../data/mock';

export const ProcessSection = () => {
  const { language } = useLanguage();

  return (
    <section className="py-20 bg-[#fefdf4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-medium text-gray-900 mb-4">{t(language, 'sections.howItWorks')}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {HOW_IT_WORKS_STEPS.map((step, index) => (
            <div key={step.number} className="relative">
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="w-16 h-16 bg-blue-900 text-white rounded-full flex items-center justify-center text-xl font-bold">
                  {step.number}
                </div>
                <h3 className="text-xl font-semibold text-gray-900">{t(language, `homePage.${step.key}`)}</h3>
                <p className="text-gray-600">{t(language, `homePage.${step.key}Desc`)}</p>
              </div>
              {index < HOW_IT_WORKS_STEPS.length - 1 && (
                <div className="hidden md:block absolute top-8 left-[60%] w-[80%] h-0.5 bg-gray-200"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
